import { render, staticRenderFns } from "./BoostStrategy.vue?vue&type=template&id=56c2b5b2&scoped=true"
import script from "./BoostStrategy.vue?vue&type=script&lang=js"
export * from "./BoostStrategy.vue?vue&type=script&lang=js"
import style0 from "./BoostStrategy.vue?vue&type=style&index=0&id=56c2b5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c2b5b2",
  null
  
)

export default component.exports